/**
 * Total mensal e formatação da extensão.
 *
 * O preço chega por pessoa no `resolve` (`prices`), e o total é somado no browser
 * conforme a retenção de dependentes do Step 3. Pessoa sem preço (`cents` nulo)
 * não bloqueia nada: entra em `unknownCount` e a tela diz "a confirmar".
 */

import { IEligiblePlan, IPersonPrice } from "./types";

export function summarizeMonthly(
  plan: IEligiblePlan,
  retainedDependentTaxPayerIds: string[]
): { knownCents: number; unknownCount: number; people: IPersonPrice[] } {
  // Dependente sem CPF (taxPayerId ""): o formulário só os identifica por CPF,
  // então vale a posição em `prices`: os N primeiros sem CPF, com N = quantos ""
  // há na lista de mantidos.
  let blankRetained = retainedDependentTaxPayerIds.filter((id) => id === "").length;

  const people = plan.prices.filter((price) => {
    if (price.personType === "TITULAR") return true;
    if (price.taxPayerId === "") return blankRetained-- > 0;

    return retainedDependentTaxPayerIds.includes(price.taxPayerId);
  });

  return {
    knownCents: people.reduce((sum, p) => sum + (p.cents ?? 0), 0),
    unknownCount: people.filter((p) => p.cents === null).length,
    people,
  };
}

/** Formata centavos como moeda brasileira. Ex.: 124000 → "R$ 1.240,00". */
export function formatCents(cents: number): string {
  return (cents / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
